require('frontend-controller/client/utils');

require('frontend-controller/styles/icons/fa62.less')

// init config
// NOTE: all elements rendered via client or have component.events defined have to be included within these contexts.
require('frontend-controller/client/config').setConfig(
    require('./clientAppConfig'),
    {
        templates:  require.context('./components/', true, /^\.\/(base\/(form|bootstrap\d*|accordion)[^/]*\/|section|collection|templates\/events\/).*\.ejs$/),
        components: require.context('./components/', true, /^\.\/(base\/(form|bootstrap\d*|accordion)[^/]*\/|section|collection|templates\/events\/).*\.js$/),
        styles:     require.context('./components/', true, /^\.\/(base\/(form|bootstrap\d*|accordion)[^/]*\/|section|collection|templates\/events\/).*\.less$/)
    }
);


// init
require('frontend-controller/client/app');
